export default "__VITE_ASSET__6302e814__"